import type { CoreOptions } from '@adyen/adyen-web'
import { useEffect } from 'react'
import { adyenPaymentMethods } from 'shared/utils/ecommerce'

type MountOneClickPaymentComponentProps = {
    paymentType: string,
    containerId: string
} & UseOneClickPaymentProps

const useMountOneClickPaymentComponent = ({
    isEnabled,
    checkout,
    configuration,
    paymentType,
    containerId
}: MountOneClickPaymentComponentProps) => {
    useEffect(() => {
        if (
            !isEnabled ||
            !checkout?.paymentMethodsResponse?.paymentMethods ||
            checkout?.paymentMethodsResponse?.paymentMethods.length === 0
        )
            return

        let oneClickPaymentComponent =
            checkout && checkout.create(paymentType, configuration)

        if (oneClickPaymentComponent) {
            oneClickPaymentComponent
                .isAvailable()
                .then(() => {
                    oneClickPaymentComponent.mount(containerId)
                })
                .catch(e => {
                    console.log(e)
                })
        }
    }, [isEnabled, checkout, configuration, paymentType, containerId])
}

type UseOneClickPaymentProps = {
    isEnabled?: boolean,
    checkout: any,
    configuration: CoreOptions
}

export const useApplePay = (props: UseOneClickPaymentProps) =>
    useMountOneClickPaymentComponent({
        ...props,
        configuration: {
            ...props.configuration,
            requiredShippingContactFields: ['name', 'phone', 'email']
        },
        paymentType: adyenPaymentMethods.APPLE_PAY,
        containerId: `#${adyenPaymentMethods.APPLE_PAY}-container`
    })

export const useGooglePay = (props: UseOneClickPaymentProps) =>
    useMountOneClickPaymentComponent({
        ...props,
        configuration: {
            ...props.configuration,
            emailRequired: true,
            shippingAddressRequired: true,
            shippingAddressParameters: {
                phoneNumberRequired: true
            }
        },
        paymentType: adyenPaymentMethods.GOOGLE_PAY,
        containerId: `#${adyenPaymentMethods.GOOGLE_PAY}-container`
    })
